module.exports = __webpack_public_path__ + "static/media/profile-cover.ef6d3ffd.jpg";